export const SUPERADMIN = "SUPERADMIN" //1
export const ADMIN = "ADMIN" //2
export const COWORKER = "COWORKER" //3
export const BILLER = "BILLER" //4
export const TECNICOS = "TECNICOS" //5
export const MANDOSJD = "MANDOSJD" //6
export const MANDOSJS = "MANDOSJS" //7
export const COORDINA = "COORDINA" //8